// 入口文件：版本检测 + 清理缓存逻辑
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import { register } from './serviceWorkerRegistration';

const originalConsoleLog = console.log.bind(console);

const shouldEnableDebugLog = () => {
  if (typeof window === 'undefined') return false;
  try {
    const raw = window.localStorage?.getItem('turn_on_debug_log');
    return typeof raw === 'string' && raw.trim().length > 0;
  } catch (_) {
    return false;
  }
};

console.log = (...args) => {
  if (shouldEnableDebugLog()) {
    originalConsoleLog(...args);
  }
};

// 获取当前构建时注入的版本号（时间戳）
const CURRENT_VERSION = process.env.REACT_APP_VERSION;
// 从 localStorage 读取上次保存的版本号
const savedVersion = localStorage.getItem('app_version');
// 判断是否生产环境
const isProd = process.env.NODE_ENV === 'production';

// ✅ 关键修复点：
// - savedVersion 为空：通常是第一次访问 / 用户清空了 localStorage / 退出登录时误清了 app_version
//   这种情况不需要清理 localStorage（否则会把刚写入的登录信息也清掉），只要写入 app_version 即可。
// - savedVersion 存在但不一致：才认为是新部署，执行清理 + reload。
let shouldHardReload = false;

if (isProd && CURRENT_VERSION) {
  if (!savedVersion) {
    // 首次访问/被清空：只写版本号，不清空
    localStorage.setItem('app_version', CURRENT_VERSION);
  } else if (savedVersion !== CURRENT_VERSION) {
    shouldHardReload = true;
  }
}

if (shouldHardReload) {
  console.info('检测到新版本，清空 localStorage 和应用缓存');
  localStorage.clear();

  // 如果环境支持 Cache API，则清理所有缓存
  if ('caches' in window) {
    caches.keys().then(keys => {
      keys.forEach(key => caches.delete(key));
    });
  }

  // 保存当前版本号，避免重复清理
  localStorage.setItem('app_version', CURRENT_VERSION);

  // 强制刷新页面，从服务器获取最新资源
  window.location.reload();
} else {
  // 版本号一致或非生产环境，正常渲染应用
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(<App />);

  reportWebVitals();

  // 只有在生产环境且已同步到最新版本时，才注册 SW
  if (isProd) register();
}
